import { useState, useContext } from 'react';
import { CiCirclePlus } from 'react-icons/ci';
import { RiDeleteBin6Line } from 'react-icons/ri';

import { PhotoProvider, PhotoView } from 'react-photo-view';
import { Language } from '../../../App';

function ImageUploader({coverImg,onImageRemove, maxNumber,fileUploadRefs, numberOfImages}) {
  const {lang} = useContext(Language)
  const [images, setImages] = useState(coverImg || []); // Start with images passed in the prop

const handleDeleteImage = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    setImages(newImages);
    if (onImageRemove) {
      onImageRemove(index);
    }
  };

  return (
    <div className="container scroll-hide overflowY-hidden overflowX-scroll">
      <div className="row d-flex flex-nowrap" >
        {images.map((image, index) => (
          <div key={index + coverImg.length} className="col-auto mb-3 position-relative">
            <div className="image-wrapper">
              <PhotoProvider
                speed={() => 800}
                easing={(type) =>
                  type === 2
                    ? 'cubic-bezier(0.36, 0, 0.66, -0.56)'
                    : 'cubic-bezier(0.34, 1.56, 0.64, 1)'
                }
              >
                <PhotoView src={image}>
                  <img
                    src={image}
                    alt={`Upload ${index + 1}`}
                    className="uploaded-image-thumbnail"
                  />
                </PhotoView>
              </PhotoProvider>
              <div className="image-options">
                <button
                  className="btn btn-link "
                  onClick={() => handleDeleteImage(index )}
                >
                  <RiDeleteBin6Line />
                </button>
                <button
                  className="btn btn-link text-primary"
                >
                  <i className="bi bi-pencil"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
        {numberOfImages < maxNumber && (
        <div className="col-auto">
          <div
            className="upload-image-button"
            onClick={() => fileUploadRefs[numberOfImages-1]?.current.click()}
          >
            <CiCirclePlus size={20} />
            <div className="mt-2">{lang.add_more_images}</div>
          </div>
        </div>)}
      </div>
    </div>
  );
}

export default ImageUploader;
